import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/mobile-global.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

declare global {
  interface Window {
    __ASSET_V__?: number;
  }
}
if (typeof window !== "undefined") {
  window.__ASSET_V__ = Date.now();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
